export default __webpack_public_path__ + "static/media/logo__technology__flowtype.9847281b.png";